<template>
  <div>
    <h4><i class="fas fa-building"></i> Small Business Rates</h4>
    <div v-if="cases && cases.length > 0" class="mb-3 text-bold">
      Total claimed: {{ cases[0].smbrr_amount_total | currency }}
    </div>
    <b-table :items="cases" :fields="['company_or_individual', 'account_ref', 'authority', 'address_line_1', 'start_date', 'rv_for_this_authority', 'sbrr_amount_for_this_authority']">
      <!-- eslint-disable-next-line -->
      <template #head(address_line_1)="data">Address</template>
      <!-- eslint-disable-next-line -->
      <template #head(sbrr_amount_for_this_authority)="data"><div class="text-right">This claim's relief</div></template>
      <!-- eslint-disable-next-line -->
      <template #head(rv_for_this_authority)="data"><div class="text-right">Rateable value</div></template>
      <template #cell(address_line_1)="data">{{ data.value }}<br/>{{ data.item.postcode }}</template>
      <template #cell(sbrr_amount_for_this_authority)="data"><div class="text-right">{{ data.value | currency }}</div></template>
      <template #cell(rv_for_this_authority)="data">
        <div v-if="hideRv !== true" class="text-right">{{ data.value | currency }}</div>
        <div v-if="hideRv === true" class="text-right"><abbr title="Not collected by this policy">N/A</abbr></div>
      </template>
      <template #cell(start_date)="data">{{ data.value | moment('DD/MM/YYYY') }}</template>
      <template #cell(authority)="data"><authority :authority="data.value"/></template>
    </b-table>
  </div>
</template>

<script>
import Authority from '../Authority.vue'

export default {
  components: { Authority },
  props: ['cases', 'hideRv'],
};
</script>